// PARAQTA — Stage 7.4 Топтар жүйесі.
// 3 segment (Менікі · Табу · Жалпы рейтинг) + Топ беті (3 tab + рейтинг toggle).
// Дизайн: design/paraqta-toptar-juyesi.html.
// Бот тимеу — group_members SOFT DELETE (left_at=NOW).

import { ugcBtn } from '../ugc/menu.js';
import { api } from '../../core/api.js';
import { toast as siteToast } from '../../utils/toast.js';
import { show, pqInitials } from '../../core/router.js';

// ── State ─────────────────────────────────────────────────────
const state = {
  segment: 'mine',           // mine | find
  groupTab: 'rank',          // talq | rank | mem
  metric: 'streak',          // streak | pages | time
  period: 'week',            // day | week | month
  currentGroup: null,        // {group_id, name, ...} — топ беті ашық кезде
  mine: null,                // { groups, count, active_count, is_premium, free_limit }
  discover: null,            // { recommended, city, city_groups, active }
  groupDetail: null,         // { group } (топ беті)
  ranking: null,             // { metric, items }
  members: null,             // { members, viewer_is_owner }
  searchResults: null,
  searchTerm: '',
};

// ── Helpers ───────────────────────────────────────────────────
const $ = (sel, root = document) => root.querySelector(sel);
const rootEl = () => document.getElementById('pg-groups');

function esc(s) {
  return String(s ?? '').replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

function initials(first, last) {
  const a = (first || '').trim();
  const b = (last || '').trim();
  if (a && b) return (a[0] + b[0]).toUpperCase();
  if (a) return a.slice(0, 2).toUpperCase();
  return 'PQ';
}

function fullName(first, last, isMe) {
  const n = [first, last].filter(Boolean).join(' ').trim() || 'Оқырман';
  return isMe ? 'Сен · ' + n : n;
}

function fmtSecs(secs) {
  const s = Math.max(0, parseInt(secs, 10) || 0);
  if (s < 60) return `${s}<small> сек</small>`;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h > 0) return `${h}<small>с</small> ${String(m).padStart(2, '0')}<small>м</small>`;
  return `${m}<small> мин</small>`;
}

// ── SVG icons ─────────────────────────────────────────────────
const SVG = {
  back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>',
  chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 18l6-6-6-6"/></svg>',
  search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>',
  people: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="9" cy="8" r="3"/><circle cx="16" cy="10" r="2.4"/><path d="M3 19c0-3 2.7-5 6-5s6 2 6 5"/></svg>',
  book: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 19V6a2 2 0 0 1 2-2h9l5 5v10"/><path d="M4 19h16"/></svg>',
  flame: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2c2 4 6 5.5 6 10.5A6 6 0 0 1 6 12.5C6 10 7 8.5 8.5 7.5c0 2 1 3 2.2 3.2C9.6 7.5 10 4.5 12 2z"/></svg>',
  clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>',
  trendUp: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M7 14l5-5 5 5"/></svg>',
  chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
  menu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="5" r="1.2"/><circle cx="12" cy="12" r="1.2"/><circle cx="12" cy="19" r="1.2"/></svg>',
  close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M6 18L18 6"/></svg>',
};

function iconClassByGroup(g) {
  const colors = ['brown', 'green', 'gold', 'orange'];
  const idx = (parseInt(g.group_id, 10) || 0) % colors.length;
  return colors[idx];
}

// ── Render: list screen (3 segments) ──────────────────────────
function renderListScreen() {
  const r = rootEl();
  if (!r) return;
  state.currentGroup = null;
  r.innerHTML = `
    <div class="gr-app">
      <div class="gr-topnav fade">
        <button class="gr-nav-btn" data-gr-action="exit" aria-label="Оқуға">${SVG.back}</button>
        <div class="gr-topnav-title">Бірге</div>
        <button class="gr-nav-btn btn-theme" data-action="theme-toggle" title="Түн/күн"
          style="margin-left:auto;">${document.documentElement.getAttribute('data-theme') === 'dark' ? '☀️' : '🌙'}</button>
        <button type="button" class="pq-nav-av" data-pq-av data-action="navigate" data-target="profile" title="Профиль" aria-label="Профиль">${pqInitials()}</button><!-- 08.10: div → button -->

      </div>

      <!-- v3: ПУЛЬС — «Тірі оқу» блогының орнын басқан бір жолдық есік
           (қазір N адам оқып отыр · M-і досың → Қосылу). coread.renderPulse. -->
      <div id="grPulse"></div>

      <!-- 24.08: Менің клубым — беттің ЕҢ ЖОҒАРЫСЫНДА (founder талабы).
           loadMine толтырады; клубы жоқ адамда бос қалады. -->
      <div id="grMyClubHero"></div>

      <!-- v3: ЛИГА блогы — өз лигаң ашық, қалғаны жиналған. -->
      <div id="grLiga"></div>

      <!-- v3: «Осы апта» — БІР оқиға слоты. Кезегі: тірі марафон → клуб
           кездесуі → дос шақыру. Бұрын марафон баннері бөлек тұратын. -->
      <div id="grMarathon"></div>

      <!-- Оқу шеңбері (отбасы / сынып) — тек шеңбері барға шығады (шартты). -->
      <div class="fade" id="cirSec" style="animation-delay:.04s;"></div>

      <!-- Ф3: Сенің шеңберің (достар + мәртебесі + түрткі) — coread толтырады. -->
      <div class="cr-sec fade" id="crSec" style="animation-delay:.05s;"></div>

      <div class="gr-grouplabel fade" style="animation-delay:.09s;font-size:12.5px;font-weight:700;letter-spacing:.4px;color:var(--ac);text-transform:uppercase;margin:0 2px 11px;display:flex;align-items:center;gap:7px;">📚 Оқу клубтары</div>

      <div class="gr-segs fade" style="animation-delay:.1s;">
        <button class="gr-seg ${state.segment === 'mine' ? 'active' : ''}" data-gr-action="seg" data-seg="mine">
          Менікі<span class="gr-seg-n" id="grMineCount"></span>
        </button>
        <button class="gr-seg ${state.segment === 'find' ? 'active' : ''}" data-gr-action="seg" data-seg="find">Табу</button>
      </div>

      <div class="gr-pane ${state.segment === 'mine' ? 'show' : ''}" id="gr-pane-mine">
        <div class="gr-loading">Жүктелуде…</div>
      </div>
      <div class="gr-pane ${state.segment === 'find' ? 'show' : ''}" id="gr-pane-find">
        <div class="gr-search fade" style="animation-delay:.08s;">
          ${SVG.search}
          <input id="grSearchInput" placeholder="Клуб атын іздеу..." value="${esc(state.searchTerm)}">
        </div>
        <div id="grFindBody"><div class="gr-loading">Жүктелуде…</div></div>
      </div>
    </div>
  `;
  loadCurrentSegment();
  // v3: Пульс + Доспен оқу. (renderLiveReading блогы пульске айналды.)
  import('../coread/index.js').then(m => {
    if (m.renderPulse) m.renderPulse(document.getElementById('grPulse'));
    m.renderCoread(document.getElementById('crSec'));
  }).catch(() => {});
  // Оқу шеңбері (отбасы/сынып панелі) — бөлек модуль, жүктелмесе бет бұзылмайды.
  import('../circle/index.js').then(m => {
    m.renderCircle_(document.getElementById('cirSec'));
  }).catch(() => {});
  // v3: лига блогы + «Осы апта» слоты — клубы жоқ адамға да көрінеді.
  renderLigaBlock();
  renderEventSlot();
}

// Марафон тизері — ТЕК тірі марафонда. end_date өтіп кетсе, көрсетпейміз.
async function renderMarathonTeaser() {
  const host = document.getElementById('grMarathon');
  if (!host) return;
  let m = null;
  try {
    const d = await api('/api/marathon/current');
    m = d && d.marathon;
  } catch (_) { return; }
  if (!m || !m.end_date) return;
  // Аяқталу күні бүгіннен бұрын болса — марафон бітті, баннер шықпайды.
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const end = new Date(m.end_date + 'T23:59:59');
  if (!(end >= today)) return;

  const prizes = (m.prizes || []).slice(0, 2)
    .map(p => `<span style="background:rgba(0,0,0,.22);border-radius:9px;padding:7px 11px;font-size:12px;">${esc(p)}</span>`)
    .join('');
  const dates = m.start_date
    ? `<span style="background:rgba(0,0,0,.22);border-radius:9px;padding:7px 11px;font-size:12px;">📅 ${esc(m.start_date)} — ${esc(m.end_date)}</span>`
    : '';
  host.className = 'fade';
  host.style.cssText = 'animation-delay:.02s;margin:0 0 18px;background:linear-gradient(150deg,#46583A,#2A3721);' +
    'border-radius:16px;padding:16px 17px;color:#EFE7CF;position:relative;overflow:hidden;cursor:pointer;' +
    '-webkit-tap-highlight-color:transparent;';
  host.setAttribute('data-action', 'open-marathon');
  host.innerHTML = `
    <div style="position:absolute;right:-10px;bottom:-18px;font-size:88px;opacity:.10;">🏁</div>
    <div style="position:relative;">
      <div style="font-size:10px;letter-spacing:1.5px;text-transform:uppercase;color:#F6CE84;font-weight:700;">🔥 Марафон · тіркелу ашық</div>
      <div style="font-family:Georgia,serif;font-size:22px;color:#fff;font-weight:600;margin-top:5px;line-height:1.15;">«${esc(m.book_title || '')}»</div>
      <div style="font-size:12.5px;color:#C9D6B8;margin-top:2px;">${esc(m.book_author || '')}</div>
      <div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:13px;">${dates}${prizes}</div>
      <div style="margin-top:13px;display:inline-flex;align-items:center;gap:6px;background:#F6CE84;color:#2A1E0B;border-radius:10px;padding:9px 15px;font-size:13px;font-weight:700;">Тіркелу <span style="font-size:15px;">→</span></div>
    </div>`;
}

async function loadCurrentSegment() {
  if (state.segment === 'mine') {
    await loadMine();
  } else if (state.segment === 'find') {
    await loadDiscover();
  }
}

// ── Pane: Менікі ──────────────────────────────────────────────
async function loadMine() {
  try {
    const res = await api('/api/groups/mine');
    state.mine = res;
    // Жаңа адам (0 топта) → бірден "Табу" сегментін көрсетеміз (топтар көрінсін).
    // Бір рет қана авто-ауысады; кейін қолмен "Менікі"-ге қайтса — қалады.
    if ((res.count || 0) === 0 && state.segment === 'mine' && !state._autoSwitched) {
      state._autoSwitched = true;
      state.segment = 'find';
      renderListScreen();
      return;
    }
    const pane = document.getElementById('gr-pane-mine');
    const cntEl = document.getElementById('grMineCount');
    if (cntEl) cntEl.textContent = res.count > 0 ? ` · ${res.count}` : '';
    if (!pane) return;
    // "Топ құру" batырмасы — тек Premium-ге
    // 24.08: клуб ашу БӘРІНЕ ТЕГІН (құлып алынды) — клуб тарату желісі.
    const createBtn = `<button class="gr-create-btn" data-gr-action="open-create">+ Клуб ашу</button>`;
    if (!res.groups || res.groups.length === 0) {
      const hb = document.getElementById('grMyClubHero');
      if (hb) hb.innerHTML = '';
      pane.innerHTML = `
        ${createBtn}
        <div class="gr-empty">
          <p>Сен әлі клубта жоқсың.</p>
          <p class="gr-empty-sub">«Табу» бөлімінен өзіңе сай клуб тап.</p>
        </div>`;
      return;
    }
    // 24.08 «Менің клубым» hero-карточкасы (мокап 5c052cd9, 1-экран):
    // негізгі клуб + апта статистикасы. Құласа — жай тізім көрсетіле береді.
    await ensureLiga();     // клуб карталарындағы лига белгілері дайын тұрсын
    let hero = '';
    try {
      const c = await ensureMyCard();
      if (c && c.club) {
        const cl = c.club;
        state.myClubGid = cl.group_id;
        const letter = esc((cl.name || '?').trim().charAt(0).toUpperCase());
        const live = cl.reading_now > 0
          ? ` · <span class="lv">🕯 қазір ${cl.reading_now} оқып отыр</span>` : '';
        // v3 ЛИГА: чип (лига + орын) · келесі меже жолы · «Менің үлесім».
        const lg = cl.liga || null;
        const chip = lg
          ? `<span class="myc-liga ${lg.league}">${LIGA_CUP[lg.league] || '🏅'} ${esc(lg.league_title).toUpperCase()} · ${lg.pos}-ОРЫН</span>`
          : '';
        let nextLine = '';
        if (lg && lg.next && (lg.next.need_avg > 0 || lg.next.need_active > 0)) {
          const parts = [];
          // 08.10: екі «орташа» шатаспасын — бұл КЛУБ деңгейі (адам басына), төмендегісі — ЖЕКЕ меже
          if (lg.next.need_avg > 0) parts.push(`адам басына тағы <b>+${lg.next.need_avg} бет</b>`);
          if (lg.next.need_active > 0) parts.push(`<b>+${lg.next.need_active} белсенді оқырман</b>`);
          nextLine = `<div class="myc-next">↑ Клубың <b>${esc(lg.next.title)}ға</b> шығуы үшін: ${parts.join(' және ')}. Айдың соңына ${daysLeftInMonth()} күн.</div>`;
        }
        // 25.08: сан плиткада тұр — мұнда тек ӘСЕРІ жазылады (қайталанбасын).
        // Орташадан төмен болса «−N бет» деп жазғырмаймыз: нақты меже береміз.
        let contrib = '';
        if (cl.my_month_pages > 0 && cl.to_avg > 0) {
          // 08.10: жеке меже «Сен …» деп анық бөлінді (клуб жолымен шатаспасын)
          contrib = `<div class="myc-my">🎯 Сен клуб орташасына жету үшін: тағы <b>${cl.to_avg} бет</b>${cl.club_avg ? ` <span style="opacity:.7">(клубта адам басына ${cl.club_avg} бет)</span>` : ''}</div>`;
        } else if (cl.my_contrib > 0) {
          contrib = `<div class="myc-my">📖 Оқығаның клуб орташасын <b>+${cl.my_contrib} бетке</b> көтерді</div>`;
        }
        hero = `
        <div class="myc fade" data-gr-action="open-group" data-gid="${cl.group_id}">
          <div class="myc-top">
            <div class="myc-emblem">${letter}</div>
            <div style="flex:1;min-width:0;">
              <div class="myc-name">${esc(cl.name)}</div>
              <div class="myc-sub">Менің клубым · ${cl.members} мүше${live}</div>
              ${chip}
            </div>
          </div>
          <div class="myc-stats">
            <div><b>${cl.month_pages ?? cl.week_pages}</b><span>клуб · ай беті</span></div>
            <div><b>${cl.my_month_pages ?? cl.my_week_pages}</b><span>сенің бетің</span></div>
            <div><b>${(cl.my_month_rank ?? cl.my_rank) ? '№' + (cl.my_month_rank ?? cl.my_rank) : '—'}</b><span>клубтағы орның</span></div>
          </div>
          ${nextLine}
          ${contrib}
          <button class="myc-go">Клуб бетіне кіру</button>
        </div>`;
      }
    } catch (_) { /* карточка міндетті емес */ }
    // 24.08 founder: hero — Бірге бетінің ЕҢ ЖОҒАРЫСЫНДА (grMyClubHero
    // контейнері, сегменттерден жоғары). Тізімде негізгі клуб қайталанбайды.
    // Достар блогы crSec-те онсыз да бар — осында ҚОСПАЙМЫЗ (қосарланған еді).
    const heroBox = document.getElementById('grMyClubHero');
    if (heroBox) heroBox.innerHTML = hero;
    const heroGid = hero ? parseInt(hero.match(/data-gid="(\d+)"/)[1], 10) : null;
    const rest = heroGid ? res.groups.filter((g) => g.group_id !== heroGid) : res.groups;
    pane.innerHTML = `
      ${createBtn}
      ${rest.length ? `<div class="gr-grp-sec">${rest.map(renderGroupRow).join('')}</div>` : ''}
    `;
  } catch (e) {
    console.warn('loadMine failed', e);
    const pane = document.getElementById('gr-pane-mine');
    if (pane) pane.innerHTML = '<div class="gr-empty"><p>Жүктеу сәтсіз болды.</p><p class="gr-empty-sub"><button class="gr-create-btn" data-gr-action="retry">Қайта көру</button></p></div>';
  }
}

// ═══ v3 ЛИГА (24.08 бекітілген мокап ceeb606b) ════════════════
const LIGA_CUP = { zhogary: '🏆', orta: '🥈', kishi: '🥉' };
const LIGA_RULES = [
  ['📖', '<b>Белсенді оқырман</b> — осы айда кемі 10 бет оқыған мүше. Бір бет ашып кеткен адам орташаны бұзбайды.'],
  ['🛡️', '<b>Шығарып тастау көмектеспейді.</b> Осы айда оқыған мүше клубтан шығарылса да, ай соңына дейін есепте қалады.'],
  ['📅', '<b>Ай сайын таза парақ.</b> Кесте айдың 1-інде нөлден басталады — лигада қалу үшін ай сайын оқу керек.'],
];

function daysLeftInMonth() {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth() + 1, 0).getDate() - n.getDate();
}

// Бір рет қана сұралатын кэштер (лига 15 мин серверде де кэштеулі).
let _ligaPromise = null;
function ensureLiga() {
  if (!_ligaPromise) _ligaPromise = api('/api/liga').catch(() => null);
  return _ligaPromise;
}
let _myCardPromise = null;
function ensureMyCard() {
  if (!_myCardPromise) {
    _myCardPromise = api('/api/clubs/my-card')
      .then((c) => {
        if (c && c.club) state.myClubGid = c.club.group_id;
        return c;
      })
      .catch(() => null);
  }
  return _myCardPromise;
}

// Клуб карточкасындағы лига белгісі («Табу»/«Менікі» тізімдері).
function ligaBadge(gid) {
  const d = state.ligaData;
  if (!d || !d.league_of) return '';
  const lo = d.league_of[gid] || d.league_of[String(gid)];
  if (lo) return `<span class="gr-lbadge ${lo.league}">${LIGA_CUP[lo.league] || ''} ${esc(lo.league_title).toUpperCase()}</span>`;
  const pre = (d.pre || []).find((p) => Number(p.gid) === Number(gid));
  if (pre) return `<span class="gr-lbadge pre">ЛИГАҒА ДЕЙІН</span>`;
  return '';
}

function _ligaRowHtml(c, pos, tier, tierIdx, leagues, myGid) {
  const me = Number(c.gid) === Number(myGid);
  let sub = '';
  // ↑ көтерілу чипі: келесі лигаға 1-2 белсенді не ≤30 бет қалғанда.
  if (tierIdx > 0) {
    const up = leagues[tierIdx - 1];
    const needAvg = Math.max(0, Math.round(up.min_avg - c.per_capita));
    const needAct = Math.max(0, up.min_active - c.active);
    if (needAct > 0 && needAct <= 2 && needAvg === 0) {
      sub = `<span class="lg-up">↑ ${esc(up.title)}ға ${needAct} белсенді оқырман қалды</span>`;
    } else if (needAvg > 0 && needAvg <= 30 && needAct === 0) {
      sub = `<span class="lg-up">↑ ${esc(up.title)}ға орташаға +${needAvg} бет</span>`;
    }
  }
  // ↓ түсу қаупі: шектен ≤10% не белсенді дәл шекте (айдың соңғы аптасында).
  if (!sub && daysLeftInMonth() <= 7 &&
      (c.per_capita <= tier.min_avg * 1.10 || c.active <= tier.min_active)) {
    sub = `<span class="lg-dn">↓ түсу қаупі: шек ${tier.min_avg}-ден ${Math.max(0, Math.round(c.per_capita - tier.min_avg))} бет қана жоғары</span>`;
  }
  return `
    <div class="lg-row ${me ? 'me' : ''}" data-gr-action="open-group" data-gid="${c.gid}">
      <span class="lg-rk">${pos}</span>
      <span class="lg-cn">${esc(c.name)}${me ? ' — <i>сенің клубың</i>' : ''}${sub}</span>
      <span class="lg-avg">${Math.round(c.per_capita)}<i>орт. бет</i></span>
    </div>`;
}

// Мереке картасы: жаңа ай басталғанда (1-3 күні) өткен айдың чемпиондары.
function _celebrationHtml(d) {
  const ch = d.champions || [];
  if (!ch.length || new Date().getDate() > 3) return '';
  const by = {};
  ch.forEach((c) => { by[c.league_key] = c; });
  const top = by.zhogary || by.orta || by.kishi;
  if (!top) return '';
  const others = ['orta', 'kishi'].filter((k) => by[k] && by[k] !== top)
    .map((k) => `<span><b>${LIGA_CUP[k]}</b> ${esc(by[k].name)}</span>`).join('');
  return `
    <div class="lg-celeb fade">
      <div class="big">🏆</div>
      <h3>${esc(_ymKk(top.ym))} чемпионы — ${esc(top.name)}</h3>
      <div class="sub">${esc(top.league_title)} · орташа ${Math.round(top.per_capita)} бет · ${top.active} белсенді</div>
      ${others ? `<div class="row3">${others}</div>` : ''}
      <button class="lg-share" data-gr-action="liga-share" data-nm="${esc(top.name)}" data-ym="${esc(top.ym)}">Клуб чатына бөлісу</button>
    </div>`;
}

const _KK_MONTHS = ['Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым',
  'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан'];
function _ymKk(ym) {
  const m = parseInt(String(ym).slice(5, 7), 10);
  return _KK_MONTHS[m - 1] || ym;
}

// ❗01.09.26 IA көшуі («Рейтинг = барлық жарыстың жалғыз үйі»):
// толық лига кестесі енді РЕЙТИНГ бетінде (Клубтар қойындысы). «Біргеде»
// тек ЖИНАҚЫ карточка қалады: өз клубыңның орны + Рейтингке сілтеме.
// Себебі: жарыс екі жерде шашылып тұрған еді, ал мектеп лигасы қосылғанда
// үшеу болар еді. Бір адам — бір көрініс ережесі.
async function renderLigaBlock() {
  const host = document.getElementById('grLiga');
  if (!host) return;
  const [d] = await Promise.all([ensureLiga(), ensureMyCard()]);
  if (!d || !d.leagues) { host.innerHTML = ''; return; }
  state.ligaData = d;
  const myGid = state.myClubGid || null;
  const myLo = myGid && d.league_of ? d.league_of[myGid] || d.league_of[String(myGid)] : null;
  let mine = '';
  if (myLo) {
    mine = `${LIGA_CUP[myLo.league] || '🏅'} ${esc(myLo.league_title)} · <b>${myLo.pos}-орын</b>`;
  } else if (myGid) {
    mine = 'клубың лигаға дейінгі топта';
  } else {
    mine = 'клубқа кір — лигаға қосыл';
  }
  host.innerHTML = `
    <div class="lg-block fade" data-gr-action="liga-reyting" style="cursor:pointer;">
      <div class="lg-head" style="border-bottom:0;">
        <span class="cup">🏆</span><b>Клубтар лигасы</b>
        <span class="m" style="margin-left:auto;font-size:11px;color:var(--ink3);">${esc(_ymKk(d.month)).toUpperCase()} · ${d.total_clubs} КЛУБ</span>
      </div>
      <div style="display:flex;align-items:center;gap:8px;padding:0 14px 12px;font-size:12.5px;color:var(--ink2);">
        <span style="flex:1;min-width:0;">${mine}</span>
        <span style="flex:none;color:var(--ac);font-weight:700;">Толық кесте → Рейтинг</span>
      </div>
    </div>`;
}

// Рейтинг бетіне толық лига көрінісін салу (Клубтар қойындысы).
// Хост — бөгде бет, сондықтан осында ӨЗ тыңдаушыларын байлаймыз
// (гр-action делегаты тек Бірге бетінде жүреді).
export async function renderLigaInto(host) {
  if (!host) return;
  host.innerHTML = '<div class="loading"><span class="spinner"></span>Жүктелуде...</div>';
  const [d] = await Promise.all([ensureLiga(), ensureMyCard()]);
  if (!d || !d.leagues) {
    host.innerHTML = '<p style="color:var(--ink4);font-size:.85rem;padding:16px">Лига дерегі жүктелмеді</p>';
    return;
  }
  state.ligaData = d;
  const myGid = state.myClubGid || null;
  const leaguesHtml = d.leagues.map((l, li) => `
    <div class="lg-block fade" style="margin-bottom:14px;">
      <div class="lg-head">
        <span class="cup">${LIGA_CUP[l.key]}</span><b class="${l.key}">${esc(l.title)}</b>
        <span class="m" style="margin-left:auto;font-size:10.5px;color:var(--ink3);">орташа ${l.min_avg}+ · белсенді ${l.min_active}+</span>
      </div>
      ${(l.rows || []).map((c, i) => _ligaRowHtml(c, i + 1, l, li, d.leagues, myGid)).join('')
        || '<div class="lg-empty">Әзірге бос — бірінші кім шығады?</div>'}
    </div>`).join('');
  host.innerHTML = `
    ${_celebrationHtml(d)}
    <div style="display:flex;align-items:center;gap:7px;font-size:11px;color:var(--ink3);margin:0 2px 12px;">
      <span>${esc(_ymKk(d.month)).toUpperCase()} · ${d.total_clubs} КЛУБ · айдың соңына ${daysLeftInMonth()} күн</span>
      <span data-lg-rules style="margin-left:auto;color:var(--ac);font-weight:700;cursor:pointer;">ⓘ лига заңы</span>
    </div>
    ${leaguesHtml}`;
  host.onclick = (e) => {
    if (e.target.closest('[data-lg-rules]')) { showLigaRules(); return; }
    const row = e.target.closest('[data-gr-action="open-group"]');
    if (row && row.dataset.gid) {
      window._pendingGroupOpen = Number(row.dataset.gid);
      import('../../core/router.js').then((m) => m.show('groups'));
    }
  };
}

// «ⓘ ережесі» — төменнен шығатын парақша (body-ге қосылады).
function showLigaRules() {
  removeLigaSheet();
  const el = document.createElement('div');
  el.id = 'grLigaSheet';
  el.setAttribute('data-gr-action', 'liga-sheet-bg');
  el.innerHTML = `
    <div class="lgs-panel">
      <div class="lgs-bar"></div>
      <div class="lgs-title">Лига заңы</div>
      ${LIGA_RULES.map(([ic, tx]) => `<div class="lgs-rule"><span>${ic}</span><span>${tx}</span></div>`).join('')}
      <button class="lgs-close" data-gr-action="liga-sheet-close">Түсінікті</button>
    </div>`;
  document.body.appendChild(el);
}
function removeLigaSheet() {
  const el = document.getElementById('grLigaSheet');
  if (el) el.remove();
}

// Толық лига беті (үш кесте + лигаға дейінгілер + заң).
async function renderLigaScreen() {
  const r = rootEl();
  if (!r) return;
  const d = state.ligaData || await ensureLiga();
  if (!d || !d.leagues) return;
  state.currentGroup = null;
  const myGid = state.myClubGid || null;
  const leaguesHtml = d.leagues.map((l, li) => `
    <div class="lg-block fade" style="margin-bottom:14px;">
      <div class="lg-head">
        <span class="cup">${LIGA_CUP[l.key]}</span><b class="${l.key}">${esc(l.title)}</b>
        <span class="m" style="margin-left:auto;font-family:var(--font-b);font-size:10.5px;color:var(--ink3);">орташа ${l.min_avg}+ · белсенді ${l.min_active}+</span>
      </div>
      ${(l.rows || []).map((c, i) => _ligaRowHtml(c, i + 1, l, li, d.leagues, myGid)).join('') || '<div class="lg-empty">Әзірге бос — бірінші кім шығады?</div>'}
    </div>`).join('');
  const pre = (d.pre || []).slice(0, 12).map((p) => {
    const need = [];
    if (p.need_active > 0) need.push(`${p.need_active} белсенді оқырман жетпейді`);
    else if (p.need_avg > 0) need.push(`орташаға +${p.need_avg} бет`);
    return `<div class="lg-pre-row" data-gr-action="open-group" data-gid="${p.gid}">${esc(p.name)} — <i>${need.join(' · ') || 'жолда'}</i></div>`;
  }).join('');
  r.innerHTML = `
    <div class="gr-app">
      <div class="gr-topnav fade">
        <button class="gr-nav-btn" data-gr-action="back-to-list" aria-label="Артқа">${SVG.back}</button>
        <div class="gr-topnav-title">Клубтар лигасы</div>
        <button class="gr-nav-btn btn-theme" data-action="theme-toggle" style="margin-left:auto;">${document.documentElement.getAttribute('data-theme') === 'dark' ? '☀️' : '🌙'}</button>
      </div>
      <div class="lg-lawline fade">Есік — <b>белсенді оқырман</b> саны · Орын — <b>орташа бет</b> · ${esc(_ymKk(d.month))} · айдың соңына ${daysLeftInMonth()} күн</div>
      ${_celebrationHtml(d)}
      ${leaguesHtml}
      ${d.pre_total ? `
      <div class="lg-block fade" style="border-style:dashed;">
        <div class="lg-head"><span class="cup">🚶</span><b>Лигаға дейін — ${d.pre_total} клуб</b></div>
        <div class="lg-pre-cap">Кіші лиганың есігі: кемі 3 белсенді оқырман және орташа 100+ бет</div>
        ${pre}
      </div>` : ''}
      <div class="lg-block fade">
        <div class="lg-head"><span class="cup">📜</span><b>Лига заңы</b></div>
        ${LIGA_RULES.map(([ic, tx]) => `<div class="lgs-rule" style="padding:10px 14px;"><span>${ic}</span><span>${tx}</span></div>`).join('')}
      </div>
    </div>`;
  window.scrollTo(0, 0);
}

// «Осы апта» — бір оқиға слоты: марафон → клуб кездесуі → дос шақыру.
async function renderEventSlot() {
  const host = document.getElementById('grMarathon');
  if (!host) return;
  await renderMarathonTeaser();               // тірі марафон болса — өзі толтырады
  if (host.innerHTML.trim()) return;
  try {
    await ensureMyCard();
    if (state.myClubGid) {
      const ex = await api(`/api/clubs/${state.myClubGid}/extras`);
      if (ex && ex.meeting && ex.meeting.dt) {
        const w = _meetDate(ex.meeting.dt);
        host.className = 'fade';
        host.innerHTML = `
          <div class="gr-event" data-gr-action="open-group" data-gid="${state.myClubGid}">
            <span class="ic">📅</span>
            <div style="flex:1;min-width:0;">
              <b>${esc(ex.meeting.topic || 'Клуб кездесуі')}</b>
              <p>${esc(w.d)} ${esc(w.mo)} · ${esc(w.t)}${ex.meeting.place ? ' · ' + esc(ex.meeting.place) : ''}</p>
            </div>
            <span class="cta">${ex.meeting.going || 0} барады</span>
          </div>`;
        return;
      }
    }
  } catch (_) { /* кездесу міндетті емес */ }
  // Дос шақыру картасы (әдепкі) — воронканың өлшенген бөгеті осы қадам.
  host.className = 'fade';
  host.innerHTML = `
    <div class="gr-event invite" data-gr-action="invite-friend">
      <span class="ic">🫂</span>
      <div style="flex:1;min-width:0;">
        <b>Досыңмен бірге оқы</b>
        <p>Бірге оқығанда әдет үзілмейді — шақыру сілтемесін жібер</p>
      </div>
      <span class="cta">Шақыру</span>
    </div>`;
}

function renderGroupRow(g) {
  const cls = iconClassByGroup(g);
  const live = g.live_count > 0
    ? `<div class="gr-live"><span class="gr-dot"></span>${g.live_count} адам оқып отыр</div>`
    : '';
  const memberCount = g.members_count || 0;
  return `
    <div class="gr-row fade" data-gr-action="open-group" data-gid="${g.group_id}">
      <div class="gr-icon ${cls}">${SVG.people}</div>
      <div class="gr-info">
        <div class="gr-name">${esc(g.name)} ${ligaBadge(g.group_id)}</div>
        <div class="gr-meta">${memberCount} мүше${g.is_owner ? ' · сен әкімшісің' : ''}</div>
        ${live}
      </div>
      <div class="gr-chev">${SVG.chev}</div>
    </div>`;
}

function renderDiscoverRow(g) {
  const cls = iconClassByGroup(g);
  const live = g.live_count > 0
    ? `<div class="gr-live"><span class="gr-dot"></span>${g.live_count} оқып отыр</div>`
    : '';
  let actionBtn;
  if (g.is_member) {
    actionBtn = `<button class="gr-join-btn joined" disabled>Мүшесің</button>`;
  } else {
    actionBtn = `<button class="gr-join-btn open" data-gr-action="join" data-gid="${g.group_id}">Қосылу</button>`;
  }
  return `
    <div class="gr-row">
      <div class="gr-icon ${cls}">${SVG.book}</div>
      <div class="gr-info" data-gr-action="open-group" data-gid="${g.group_id}">
        <div class="gr-name">${esc(g.name)} ${ligaBadge(g.group_id)}</div>
        <div class="gr-meta">${g.members_count || 0} мүше · ашық клуб</div>
        ${live}
      </div>
      ${actionBtn}
    </div>`;
}

// ── Pane: Табу ────────────────────────────────────────────────
async function loadDiscover() {
  try {
    await ensureLiga();   // карточкалардағы лига белгілері үшін
    const res = await api('/api/groups/discover');
    state.discover = res;
    renderDiscoverBody();
  } catch (e) {
    console.warn('loadDiscover failed', e);
    const body = document.getElementById('grFindBody');
    if (body) body.innerHTML = '<div class="gr-empty"><p>Жүктеу сәтсіз болды.</p><p class="gr-empty-sub"><button class="gr-create-btn" data-gr-action="retry">Қайта көру</button></p></div>';
  }
}

function renderDiscoverBody() {
  const body = document.getElementById('grFindBody');
  if (!body) return;
  const d = state.discover || {};
  const sections = [];
  if (state.searchResults) {
    if (state.searchResults.length === 0) {
      sections.push(`
        <div class="gr-grp-sec fade">
          <div class="gr-sec-tag">Іздеу нәтижесі</div>
          <div class="gr-empty"><p>«${esc(state.searchTerm)}» бойынша клуб табылмады.</p></div>
        </div>`);
    } else {
      sections.push(`
        <div class="gr-grp-sec fade">
          <div class="gr-sec-tag">Іздеу нәтижесі (${state.searchResults.length})</div>
          ${state.searchResults.map(renderDiscoverRow).join('')}
        </div>`);
    }
  } else {
    if (d.recommended && d.recommended.length) {
      sections.push(`
        <div class="gr-grp-sec fade" style="animation-delay:.12s;">
          <div class="gr-sec-tag">✦ Саған сай — ұсынылған</div>
          ${d.recommended.map(renderDiscoverRow).join('')}
        </div>`);
    }
    if (d.city && d.city_groups && d.city_groups.length) {
      sections.push(`
        <div class="gr-grp-sec fade" style="animation-delay:.16s;">
          <div class="gr-sec-tag">🏙️ ${esc(d.city)} клубтары</div>
          ${d.city_groups.map(renderDiscoverRow).join('')}
        </div>`);
    }
    if (d.active && d.active.length) {
      sections.push(`
        <div class="gr-grp-sec fade" style="animation-delay:.2s;">
          <div class="gr-sec-tag">🔥 Белсенді клубтар</div>
          ${d.active.map(renderDiscoverRow).join('')}
        </div>`);
    }
  }
  if (sections.length === 0) {
    sections.push('<div class="gr-empty"><p>Клубтар жоқ.</p></div>');
  }
  body.innerHTML = sections.join('');
}

let _searchTimer = null;
function onSearchInput(value) {
  state.searchTerm = value;
  clearTimeout(_searchTimer);
  _searchTimer = setTimeout(async () => {
    const q = state.searchTerm.trim();
    if (q.length < 2) {
      state.searchResults = null;
      renderDiscoverBody();
      return;
    }
    try {
      const res = await api(`/api/groups/search?query=${encodeURIComponent(q)}`);
      state.searchResults = res.results || [];
      renderDiscoverBody();
    } catch (e) {
      console.warn('search failed', e);
    }
  }, 350);
}

// ── Pane: Жалпы рейтинг ───────────────────────────────────────
async function loadGlobal() {
  try {
    const res = await api('/api/groups/global-ranking');
    state.global = res;
    renderGlobal();
  } catch (e) {
    console.warn('loadGlobal failed', e);
    siteToast('Рейтингті жүктеу сәтсіз');
  }
}

function renderGlobal() {
  const pane = document.getElementById('gr-pane-global');
  if (!pane) return;
  const g = state.global || {};
  const banner = `
    <div class="gr-rank-banner fade" style="animation-delay:.08s;">
      <div class="gr-rmb-pos">#${g.my_rank || '—'}</div>
      <div class="gr-rmb-info">
        <div class="gr-rmb-name">Сенің жалпы орның</div>
        <div class="gr-rmb-sub">${g.total || 0} оқырманнан${g.my_city ? ' · ' + esc(g.my_city) : ''}</div>
      </div>
      ${g.my_streak ? `<div class="gr-rmb-trend">${SVG.trendUp}${g.my_streak}</div>` : ''}
    </div>`;
  const top = (g.top || []).map((u, i) => {
    const pos = i + 1;
    const posCls = pos <= 3 ? ' gold' : '';
    const name = fullName(u.first_name, u.last_name, false);
    return `
      <div class="gr-rank-item">
        <div class="gr-ri-pos${posCls}">${pos}</div>
        <div class="gr-ri-av">${esc(initials(u.first_name, u.last_name))}</div>
        <div class="gr-ri-info">
          <div class="gr-ri-name">${esc(name)}</div>
          ${u.city ? `<div class="gr-ri-city">${esc(u.city)}</div>` : ''}
        </div>
        <div class="gr-ri-val">${u.streak || 0}<small> күн</small></div>
      </div>`;
  }).join('');
  pane.innerHTML = `
    ${banner}
    <div class="gr-sec-tag fade" style="margin-top:18px;animation-delay:.12s;">🏆 PARAQTA — ең көп оқитындар</div>
    <div class="gr-rank-list fade" style="animation-delay:.14s;">
      ${top || '<div class="gr-empty"><p>Рейтинг бос.</p></div>'}
    </div>
  `;
}

// ── Group detail screen ───────────────────────────────────────
async function openGroup(groupId) {
  state.currentGroup = { group_id: groupId };
  state.groupDetail = null;
  state.ranking = null;
  state.members = null;
  state.groupTab = 'rank';
  state.metric = 'streak';
  renderGroupShell(groupId);
  try {
    const res = await api(`/api/groups/${groupId}`);
    state.groupDetail = res.group;
    renderGroupShell(groupId);
    loadExtras(groupId);          // Ф2: кездесу · дауыс · чат (параллель)
    await loadRanking();
  } catch (e) {
    console.warn('openGroup failed', e);
    siteToast('Клуб жүктеу сәтсіз');
  }
}

// ── Ф2 (24.08): кездесу · дауыс беру · чат сілтемесі ─────────
async function loadExtras(groupId) {
  try {
    state.extras = await api(`/api/clubs/${groupId}/extras`);
  } catch (_) {
    state.extras = null;
  }
  renderExtras();
}

function _meetDate(dt) {
  // 'YYYY-MM-DD HH:MM' → {d: '27', mo: 'қыр', t: '16:00'}
  const MO = ['қаң','ақп','нау','сәу','мам','мау','шіл','там','қыр','қаз','қар','жел'];
  const m = String(dt || '').match(/^(\d{4})-(\d{2})-(\d{2})[T ]?(\d{2}:\d{2})?/);
  if (!m) return { d: '?', mo: '', t: '' };
  return { d: String(parseInt(m[3], 10)), mo: MO[parseInt(m[2], 10) - 1] || '', t: m[4] || '' };
}

function renderExtras() {
  const box = document.getElementById('grExtras');
  if (!box) return;
  const ex = state.extras;
  if (!ex) { box.innerHTML = ''; return; }
  let h = '';

  // 24.08 v2: статистика плиткалары мен белдіктер — ХИРО ішіне (clubHeroX),
  // мокаптағыдай. Бәрі есептелген дерек, қолмен қойылмайды.
  const hx = document.getElementById('clubHeroX');
  if (hx) {
    if (ex.stats) {
      const st = ex.stats;
      const fmtK = (n) => (n >= 1000 ? Math.round(n / 1000) + 'к' : String(n));
      const chips = [];
      if (st.books_finished >= 20) chips.push(`🏅 ${st.books_finished >= 100 ? '100+' : st.books_finished >= 50 ? '50+' : '20+'} кітап`);
      if (st.age_weeks >= 4) chips.push(`🔥 ${st.age_weeks} апта бірге`);
      if (st.rank && st.rank <= 3) chips.push(`${['🥇', '🥈', '🥉'][st.rank - 1]} лига көшбасшысы`);
      hx.innerHTML = `
        <div class="club-tiles">
          <div><b>${st.rank ? '№' + st.rank : '—'}</b><span>лигада (${st.liga_clubs} клуб)</span></div>
          <div><b>${st.books_finished}</b><span>кітап бітірілді</span></div>
          <div><b>${fmtK(st.total_pages)}</b><span>барлық бет</span></div>
        </div>
        ${chips.length ? `<div class="club-chips">${chips.map((c) => `<span>${c}</span>`).join('')}</div>` : ''}`;
    } else {
      hx.innerHTML = '';
    }
  }

  if (ex.meeting) {
    const mt = ex.meeting;
    const w = _meetDate(mt.dt);
    const qN = (mt.questions || '').split('\n').filter((s) => s.trim()).length;
    h += `
    <div class="cx-card cx-meet fade">
      <div class="cx-date"><b>${esc(w.d)}</b><span>${esc(w.mo)}</span></div>
      <div style="flex:1;min-width:0;">
        <h4>${esc(mt.topic || 'Клуб кездесуі')}</h4>
        <p>${esc(w.t)}${mt.place ? ' · ' + esc(mt.place) : ''}${qN ? ` · ${qN} талқылау сұрағы` : ''}</p>
        ${ex.is_member ? `
        <button class="cx-rsvp ${mt.me_going ? 'on' : ''}" data-gr-action="rsvp">
          ${mt.me_going ? '✓ Барамын' : 'Барамын'} · ${mt.going}
        </button>` : ''}
      </div>
    </div>`;
  }

  if (ex.vote) {
    const v = ex.vote;
    const total = Math.max(1, v.total);
    h += `
    <div class="cx-card fade">
      <div class="cx-vote-q">🗳 ${esc(v.question)}</div>
      ${v.options.map((o, i) => {
        const pct = Math.round((v.counts[i] / total) * 100);
        const sel = v.my_idx === i;
        return `
        <div class="cx-opt ${sel ? 'sel' : ''}" data-gr-action="vote-cast" data-idx="${i}"${ex.is_member ? '' : ' style="cursor:default;"'}>
          <i style="width:${pct}%;"></i>
          <span class="t"><span>${esc(o)}${sel ? ' ✓' : ''}</span><b>${pct}%</b></span>
        </div>`;
      }).join('')}
      <div class="cx-cap">${v.total} дауыс${v.ends_at ? ' · жабылады: ' + esc(v.ends_at) : ''}</div>
    </div>`;
  }

  if (ex.chat_url) {
    // Дерегі толық емес адамға чаттың алдында қысқа анкета шығады: чат —
    // адам ЕҢ ҚАЛАЙТЫН нәрсе, сондықтан ынта дәл осында ең жоғары.
    // Ботта тіркелгендерге need_profile=false → анкета мүлдем көрінбейді.
    // ?gate=1 — анкетаны МӘЖБҮРЛЕП көрсету (тек тексеру үшін: дерегі толық
    // адамға әдетте шықпайды, сондықтан founder оны көре алмайды).
    let _forceGate = false;
    try { _forceGate = new URLSearchParams(location.search).has('gate'); } catch (_) {}
    h += (ex.need_profile || _forceGate)
      ? `<button class="cx-card cx-chat fade" data-gr-action="chat-gate"
           data-url="${esc(ex.chat_url)}">
           <span class="ic">💬</span><b>Клуб чаты</b><span class="go">кіру →</span>
         </button>`
      : `<a href="${esc(ex.chat_url)}" target="_blank" rel="noopener" class="cx-card cx-chat fade">
           <span class="ic">💬</span><b>Клуб чаты</b><span class="go">кіру →</span>
         </a>`;
  }

  box.innerHTML = h;
}

// ── Чат алдындағы анкета ────────────────────────────────────────────
// ❗ҚАУІПСІЗ ҚҰЛАУ: қандай қате болса да чат сілтемесі ашылады. Анкета —
// дерек жинау құралы, БӨГЕТ емес. Пикникте 100 адам осы қадамнан өтеді,
// ал кіре алмаған адам қайтып келмейді.
function openProfileGate(url) {
  const go = () => { try { window.open(url, '_blank', 'noopener'); } catch (_) { location.href = url; } };
  if (!url) return;
  const old = document.getElementById('pgGate');
  if (old) old.remove();
  const m = document.createElement('div');
  m.id = 'pgGate';
  m.className = 'gr-modal-bg';
  m.innerHTML = `
    <div class="gr-modal">
      <div class="gr-modal-title">Танысып алайық</div>
      <p style="margin:0 0 14px;font-size:.86rem;color:var(--ink3)">
        Клуб чатына өтпес бұрын өзің туралы қысқаша жаз — кімдер оқып
        жүргенін білу үшін.</p>
      <label class="gr-field"><span>Аты-жөні</span>
        <input class="gr-input" id="pgName" maxlength="120" autocomplete="name"></label>
      <label class="gr-field"><span>Телефон</span>
        <input class="gr-input" id="pgPhone" type="tel" inputmode="numeric"
               placeholder="+7 700 000 00 00" maxlength="18" autocomplete="tel"></label>
      <label class="gr-field"><span>Туған жылың</span>
        <input class="gr-input" id="pgYear" type="number" inputmode="numeric"
               placeholder="2005" min="1930" max="2020"></label>
      <label class="gr-field"><span>Қалаң</span>
        <input class="gr-input" id="pgCity" maxlength="80" placeholder="Астана"></label>
      <div class="gr-field"><span>Жынысы</span>
        <div style="display:flex;gap:8px;margin-top:6px">
          <button type="button" class="gr-gd-tab" data-g="m">Ер</button>
          <button type="button" class="gr-gd-tab" data-g="f">Әйел</button>
        </div></div>
      <button class="gr-modal-btn" id="pgSave" style="margin-top:14px;width:100%">Сақтап, чатқа өту →</button>
      <button id="pgSkip" style="margin-top:10px;width:100%;background:none;border:0;
              color:var(--ink3);font-size:.84rem;cursor:pointer">Кейін толтырам</button>
    </div>`;
  document.body.appendChild(m);
  let gender = '';
  m.querySelectorAll('[data-g]').forEach((b) => {
    b.onclick = () => {
      gender = b.dataset.g;
      m.querySelectorAll('[data-g]').forEach((x) => x.classList.toggle('on', x === b));
    };
  });
  m.onclick = (e) => { if (e.target === m) { m.remove(); } };
  m.querySelector('#pgSkip').onclick = () => { m.remove(); go(); };
  m.querySelector('#pgSave').onclick = async () => {
    const btn = m.querySelector('#pgSave');
    btn.disabled = true; btn.textContent = 'Сақталуда…';
    try {
      await fetch('/api/profile/complete', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: (m.querySelector('#pgName').value || '').trim(),
          phone: (m.querySelector('#pgPhone').value || '').trim(),
          birth_year: parseInt(m.querySelector('#pgYear').value, 10) || null,
          city: (m.querySelector('#pgCity').value || '').trim(),
          gender,
        }),
      });
    } catch (_) { /* сақталмаса да чатқа жібереміз */ }
    m.remove();
    go();
  };
}

async function doRsvp() {
  if (!state.currentGroup) return;
  try {
    await api(`/api/clubs/${state.currentGroup.group_id}/meeting/rsvp`, { method: 'POST' });
    loadExtras(state.currentGroup.group_id);
  } catch (_) { siteToast('Жасалмады'); }
}

async function doVoteCast(idx) {
  if (!state.currentGroup || !state.extras || !state.extras.is_member) return;
  try {
    await api(`/api/clubs/${state.currentGroup.group_id}/vote/cast`, {
      method: 'POST', body: JSON.stringify({ opt_idx: idx }),
    });
    loadExtras(state.currentGroup.group_id);
  } catch (_) { siteToast('Дауыс өтпеді'); }
}

async function doMeetPub() {
  const gid = state.currentGroup && state.currentGroup.group_id;
  if (!gid) return;
  const d = (document.getElementById('grMeetDate') || {}).value;
  const t = (document.getElementById('grMeetTime') || {}).value || '16:00';
  if (!d) { siteToast('Күнін таңда'); return; }
  try {
    await api(`/api/clubs/${gid}/meeting`, { method: 'POST', body: JSON.stringify({
      dt: `${d} ${t}`,
      topic: (document.getElementById('grMeetTopic') || {}).value || '',
      place: (document.getElementById('grMeetPlace') || {}).value || '',
      questions: (document.getElementById('grMeetQ') || {}).value || '',
    }) });
    siteToast('Кездесу жарияланды ✓');
    removeAdminModal();
    loadExtras(gid);
  } catch (_) { siteToast('Жарияланбады'); }
}

async function doVoteOpen() {
  const gid = state.currentGroup && state.currentGroup.group_id;
  if (!gid) return;
  const qv = (document.getElementById('grVoteQ') || {}).value || '';
  const opts = ['grVoteO1', 'grVoteO2', 'grVoteO3']
    .map((id) => ((document.getElementById(id) || {}).value || '').trim())
    .filter(Boolean);
  if (!qv.trim() || opts.length < 2) { siteToast('Сұрақ + кемінде 2 нұсқа'); return; }
  try {
    await api(`/api/clubs/${gid}/vote`, { method: 'POST', body: JSON.stringify({
      question: qv, options: opts, days: 7,
    }) });
    siteToast('Дауыс ашылды ✓');
    removeAdminModal();
    loadExtras(gid);
  } catch (_) { siteToast('Ашылмады'); }
}

async function doBroadcast() {
  const gid = state.currentGroup && state.currentGroup.group_id;
  if (!gid) return;
  const text = ((document.getElementById('grBcast') || {}).value || '').trim();
  if (text.length < 3) { siteToast('Хабар тым қысқа'); return; }
  try {
    const r = await api(`/api/clubs/${gid}/broadcast`, {
      method: 'POST', body: JSON.stringify({ text }),
    });
    siteToast(`Жіберілді: ${r.sent} мүшеге ✓`);
    removeAdminModal();
  } catch (e) {
    siteToast('Бүгінгі хабар лимиті бітті (күніне 1)');
  }
}

async function doChatSave() {
  const gid = state.currentGroup && state.currentGroup.group_id;
  if (!gid) return;
  const url = ((document.getElementById('grChatUrl') || {}).value || '').trim();
  try {
    await api(`/api/clubs/${gid}/settings`, {
      method: 'POST', body: JSON.stringify({ chat_url: url }),
    });
    siteToast('Сақталды ✓');
    removeAdminModal();
    loadExtras(gid);
  } catch (_) { siteToast('Тек t.me / chat.whatsapp.com сілтемесі'); }
}

function renderGroupShell(groupId) {
  const r = rootEl();
  if (!r) return;
  const g = state.groupDetail;
  // 24.08 v2: алтын жиекті эмблема-әріп (мокап тілі) + статистика плиткалары
  // (clubHeroX — extras жүктелгенде толады: лига орны · кітап · бет · белдіктер)
  const heroBody = g
    ? `
      <div class="club-emblem">${esc((g.name || '?').trim().charAt(0).toUpperCase())}</div>
      <div class="gr-gd-name">${esc(g.name)}</div>
      <div class="gr-gd-meta">${g.members_count} мүше${g.city ? ' · ' + esc(g.city) : ''}${g.is_owner ? ' · сен басшысың' : ''}</div>
      ${g.live_count > 0 ? `<div class="gr-gd-live"><span class="gr-dot"></span>🕯 Дәл қазір ${g.live_count} адам оқып отыр</div>` : ''}
      <div id="clubHeroX"></div>
      ${g.description ? `<div class="gr-gd-desc">${esc(g.description)}</div>` : ''}
    `
    : '<div class="gr-loading">Жүктелуде…</div>';

  const adminBtn = g && g.is_owner
    ? `<button class="gr-nav-btn" data-gr-action="open-admin">${SVG.menu}</button>`
    : '<div style="width:36px;"></div>';

  r.innerHTML = `
    <div class="gr-app">
      <div class="gr-topnav fade">
        <button class="gr-nav-btn" data-gr-action="back-to-list">${SVG.back}</button>
        <div class="gr-topnav-title">Клуб</div>
        ${adminBtn}
      </div>

      <div class="gr-gd-hero fade" style="animation-delay:.05s;">
        ${heroBody}
      </div>

      <div id="grExtras"></div>

      <div class="gr-gd-tabs fade" style="animation-delay:.1s;">
        <button class="gr-gd-tab ${state.groupTab === 'talq' ? 'active' : ''}" data-gr-action="gtab" data-gtab="talq">Талқылау</button>
        <button class="gr-gd-tab ${state.groupTab === 'rank' ? 'active' : ''}" data-gr-action="gtab" data-gtab="rank">Рейтинг</button>
        <button class="gr-gd-tab ${state.groupTab === 'mem' ? 'active' : ''}" data-gr-action="gtab" data-gtab="mem">Мүшелер</button>
      </div>

      <div id="grGroupBody"><div class="gr-loading">Жүктелуде…</div></div>

      ${g && !g.is_owner && g.is_member
        ? `<button class="gr-leave-btn" data-gr-action="leave">Клубтан шығу</button>`
        : ''}
    </div>
  `;
  renderGroupBody();
}

function renderGroupBody() {
  const body = document.getElementById('grGroupBody');
  if (!body) return;
  if (state.groupTab === 'talq') {
    loadPosts();
    return;
  }
  if (state.groupTab === 'rank') {
    renderRanking(body);
    return;
  }
  if (state.groupTab === 'mem') {
    renderMembers(body);
    return;
  }
}

// ── Талқы (топ посттары + жауаптар) ───────────────────────────
function _ago(iso) {
  if (!iso) return '';
  const t = new Date(String(iso).replace(' ', 'T')).getTime();
  if (isNaN(t)) return '';
  const s = Math.floor((Date.now() - t) / 1000);
  if (s < 60) return 'қазір';
  if (s < 3600) return Math.floor(s / 60) + ' мин';
  if (s < 86400) return Math.floor(s / 3600) + ' сағ';
  if (s < 604800) return Math.floor(s / 86400) + ' күн';
  return String(iso).slice(0, 10);
}
const _av = (name) => esc(String(name || '?').trim().slice(0, 2).toUpperCase());

async function loadPosts() {
  const body = document.getElementById('grGroupBody');
  if (!body || !state.currentGroup) return;
  body.innerHTML = '<div class="gr-loading">Жүктелуде…</div>';
  const gid = state.currentGroup.group_id;
  let res;
  try { res = await api(`/api/groups/${gid}/posts`); }
  catch (e) { res = null; }
  if (!res) {
    body.innerHTML = '<div class="gr-empty"><p>Жүктеу сәтсіз.</p><p class="gr-empty-sub"><button class="gr-create-btn" data-gr-action="gtab" data-gtab="talq">Қайта көру</button></p></div>';
    return;
  }
  const posts = res.posts || [];
  const isMember = !!res.is_member;
  const composer = isMember ? `
    <div class="gr-talq-composer">
      <textarea id="grPostInput" class="gr-talq-ta" rows="2" maxlength="2000" placeholder="Клубқа жаз — ой бөліс, сұрақ қой, талқыла…"></textarea>
      <button class="gr-talq-send" data-gr-action="post-submit">Жіберу</button>
    </div>` : `<div class="gr-talq-join">💬 Жазу үшін клубқа кір</div>`;
  const list = posts.length
    ? posts.map(p => renderPost(p, isMember)).join('')
    : '<div class="gr-talq-empty">Әзірге талқы жоқ — бірінші болып жаз! ✍️</div>';
  body.innerHTML = `
    <style>
      .gr-talq{display:flex;flex-direction:column;gap:12px;padding:4px 2px 24px;}
      .gr-talq-composer{display:flex;flex-direction:column;gap:8px;background:var(--card);border:.5px solid color-mix(in srgb,var(--ink) 8%,transparent);border-radius:14px;padding:12px;}
      .gr-talq-ta{width:100%;border:none;background:var(--bg2);border-radius:10px;padding:11px;font:inherit;font-size:14px;color:var(--ink);resize:vertical;box-sizing:border-box;}
      .gr-talq-send{align-self:flex-end;background:var(--ac);color:var(--bg);border:none;border-radius:999px;padding:9px 22px;font-size:13px;font-weight:700;cursor:pointer;font-family:Onest,sans-serif;}
      .gr-talq-join{text-align:center;color:var(--ink3);font-size:13px;padding:14px;background:var(--bg2);border-radius:12px;}
      .gr-talq-empty{text-align:center;color:var(--ink3);font-size:13px;padding:30px 14px;}
      .gr-talq-post{background:var(--card);border:.5px solid color-mix(in srgb,var(--ink) 8%,transparent);border-radius:14px;padding:13px 14px;}
      .gr-talq-head{display:flex;align-items:center;gap:8px;margin-bottom:7px;}
      .gr-talq-av{width:28px;height:28px;border-radius:50%;background:color-mix(in srgb,var(--ac) 16%,transparent);color:var(--ac);display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;flex-shrink:0;}
      .gr-talq-author{font-size:13px;font-weight:600;color:var(--ink);}
      .gr-talq-time{font-size:11px;color:var(--ink4);}
      .gr-talq-del{margin-left:auto;background:none;border:none;color:var(--ink4);cursor:pointer;font-size:14px;}
      .gr-talq-body{font-size:14px;color:var(--ink);line-height:1.5;white-space:pre-wrap;word-break:break-word;}
      .gr-talq-replies{margin-top:9px;padding-left:11px;border-left:2px solid color-mix(in srgb,var(--ink) 8%,transparent);display:flex;flex-direction:column;gap:6px;}
      .gr-talq-reply{font-size:13px;line-height:1.45;}
      .gr-talq-rauthor{font-weight:600;color:var(--ac);margin-right:5px;}
      .gr-talq-rbody{color:var(--ink2);white-space:pre-wrap;word-break:break-word;}
      .gr-talq-replybox{display:flex;gap:6px;margin-top:9px;}
      .gr-talq-rinput{flex:1;border:none;background:var(--bg2);border-radius:999px;padding:8px 13px;font:inherit;font-size:13px;color:var(--ink);box-sizing:border-box;}
      .gr-talq-rsend{background:none;border:none;color:var(--ac);font-size:17px;cursor:pointer;padding:0 6px;}
    </style>
    <div class="gr-talq fade">${composer}${list}</div>`;
}

function renderPost(p, isMember) {
  const replies = (p.replies || []).map(r => `
    <div class="gr-talq-reply"><span class="gr-talq-rauthor">${esc(r.author_name)}</span><span class="gr-talq-rbody">${esc(r.body)}</span>${r.mine ? '' : ugcBtn('group_reply', r.id, r.telegram_id)}</div>`).join('');
  const replyBox = isMember ? `
    <div class="gr-talq-replybox">
      <input class="gr-talq-rinput" id="grReply-${p.id}" maxlength="2000" placeholder="Жауап жаз…">
      <button class="gr-talq-rsend" data-gr-action="reply-submit" data-pid="${p.id}" aria-label="Жауап">➤</button>
    </div>` : '';
  return `
    <div class="gr-talq-post">
      <div class="gr-talq-head">
        <span class="gr-talq-av">${_av(p.author_name)}</span>
        <span class="gr-talq-author">${esc(p.author_name)}</span>
        <span class="gr-talq-time">${_ago(p.created_at)}</span>
        ${p.mine ? `<button class="gr-talq-del" data-gr-action="post-delete" data-pid="${p.id}" aria-label="Өшіру">✕</button>` : ugcBtn('group_post', p.id, p.telegram_id)}
      </div>
      <div class="gr-talq-body">${esc(p.body)}</div>
      ${replies ? `<div class="gr-talq-replies">${replies}</div>` : ''}
      ${replyBox}
    </div>`;
}

async function submitPost() {
  const ta = document.getElementById('grPostInput');
  if (!ta || !state.currentGroup) return;
  const text = ta.value.trim();
  if (!text) return;
  ta.disabled = true;
  const gid = state.currentGroup.group_id;
  const res = await api(`/api/groups/${gid}/posts`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body: text }),
  });
  ta.disabled = false;
  if (res && res.ok) { ta.value = ''; loadPosts(); }
  else siteToast('Жіберілмеді — қайталап көр');
}

async function submitReply(pid) {
  const inp = document.getElementById('grReply-' + pid);
  if (!inp || !state.currentGroup) return;
  const text = inp.value.trim();
  if (!text) return;
  const gid = state.currentGroup.group_id;
  const res = await api(`/api/groups/${gid}/posts/${pid}/reply`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body: text }),
  });
  if (res && res.ok) loadPosts();
  else siteToast('Жіберілмеді');
}

async function deletePost(pid) {
  if (!state.currentGroup) return;
  const gid = state.currentGroup.group_id;
  const res = await api(`/api/groups/${gid}/posts/${pid}/delete`, { method: 'POST' });
  if (res && res.ok) loadPosts();
}

// ── Ranking (streak / pages / time × day/week/month) ──────────
async function loadRanking() {
  if (!state.currentGroup) return;
  const gid = state.currentGroup.group_id;
  try {
    const res = await api(`/api/groups/${gid}/ranking?metric=${state.metric}&period=${state.period}`);
    state.ranking = res;
    if (state.groupTab === 'rank') renderGroupBody();
  } catch (e) {
    console.warn('loadRanking failed', e);
  }
}

function renderRanking(body) {
  const data = state.ranking;
  // Streak-те period ескерілмейді (лайфтайм streak)
  const showPeriod = state.metric !== 'streak';
  body.innerHTML = `
    <div class="gr-metric-toggle">
      <button class="gr-metric-btn ${state.metric === 'streak' ? 'active' : ''}" data-gr-action="metric" data-metric="streak">
        ${SVG.flame} Streak
      </button>
      <button class="gr-metric-btn ${state.metric === 'pages' ? 'active' : ''}" data-gr-action="metric" data-metric="pages">
        ${SVG.book} Беттер
      </button>
      <button class="gr-metric-btn ${state.metric === 'time' ? 'active' : ''}" data-gr-action="metric" data-metric="time">
        ${SVG.clock} Уақыт
      </button>
    </div>
    ${showPeriod ? `
    <div class="gr-period-toggle">
      <button class="gr-period-btn ${state.period === 'day' ? 'active' : ''}" data-gr-action="period" data-period="day">Бүгін</button>
      <button class="gr-period-btn ${state.period === 'week' ? 'active' : ''}" data-gr-action="period" data-period="week">Апта</button>
      <button class="gr-period-btn ${state.period === 'month' ? 'active' : ''}" data-gr-action="period" data-period="month">Ай</button>
    </div>` : ''}
    <div id="grRankList">${
      data && data.items
        ? renderRankItems(data.items, state.metric)
        : '<div class="gr-loading">Жүктелуде…</div>'
    }</div>
  `;
}

function renderRankItems(items, metric) {
  if (!items.length) return '<div class="gr-empty"><p>Рейтинг бос.</p></div>';
  return `<div class="gr-rank-list">${items.map(item => {
    const pos = item.position;
    const posCls = pos <= 3 ? ' gold' : '';
    const meCls = item.is_me ? ' me' : '';
    const name = fullName(item.first_name, item.last_name, item.is_me);
    // Бас мәні (таңдалған metric)
    let primaryValue;
    if (metric === 'time') primaryValue = fmtSecs(item.seconds);
    else if (metric === 'pages') primaryValue = `${item.pages}<small> бет</small>`;
    else primaryValue = `${item.streak}<small> күн</small>`;
    // Қосымша stats (барлық 3-уі толық — кіші өрнегінде)
    const extraStats = `
      <div class="gr-ri-stats">
        <span>${item.streak}<small>д</small></span>
        <span>${item.pages}<small>б</small></span>
        <span>${fmtSecs(item.seconds)}</span>
      </div>`;
    return `
      <div class="gr-rank-item${meCls}">
        <div class="gr-ri-pos${posCls}">${pos}</div>
        <div class="gr-ri-av">${esc(initials(item.first_name, item.last_name))}</div>
        <div class="gr-ri-info">
          <div class="gr-ri-name">${esc(name)}</div>
          ${extraStats}
        </div>
        <div class="gr-ri-val">${primaryValue}</div>
      </div>`;
  }).join('')}</div>`;
}

// ── Members ───────────────────────────────────────────────────
async function loadMembers() {
  if (!state.currentGroup) return;
  const gid = state.currentGroup.group_id;
  try {
    const res = await api(`/api/groups/${gid}/members`);
    state.members = res;
    if (state.groupTab === 'mem') renderGroupBody();
  } catch (e) {
    console.warn('loadMembers failed', e);
  }
}

function renderMembers(body) {
  const data = state.members;
  if (!data) {
    body.innerHTML = '<div class="gr-loading">Жүктелуде…</div>';
    return;
  }
  if (!data.members.length) {
    body.innerHTML = '<div class="gr-empty"><p>Мүшелер табылмады.</p></div>';
    return;
  }
  const ownerKick = data.viewer_is_owner;
  body.innerHTML = `<div class="gr-mem-list">${
    data.members.map(m => {
      const name = fullName(m.first_name, m.last_name, m.is_me);
      const badge = m.is_owner ? '<span class="gr-mem-badge">әкімші</span>' : '';
      const kickBtn = (ownerKick && !m.is_me && !m.is_owner)
        ? `<button class="gr-mem-kick" data-gr-action="kick" data-tid="${m.telegram_id}">Шығару</button>`
        : '';
      return `
        <div class="gr-mem-row">
          <div class="gr-mem-av">${esc(initials(m.first_name, m.last_name))}</div>
          <div class="gr-mem-info">
            <div class="gr-mem-name">${esc(name)} ${badge}</div>
            <div class="gr-mem-sub">${m.streak || 0} күн streak${m.city ? ' · ' + esc(m.city) : ''}</div>
          </div>
          ${kickBtn}
        </div>`;
    }).join('')
  }</div>`;
}

// ── Join (with gating) ────────────────────────────────────────
async function joinGroup(groupId) {
  try {
    const res = await api(`/api/groups/${groupId}/join`, { method: 'POST' });
    if (res.status === 'premium_required') {
      try {
        const mod = await import('../premium-lock/modal.js');
        mod.showPremiumLockModal('group-join');
      } catch (_) {
        siteToast(res.reason || 'PARAQTA-ның Жан досы болыңыз');
      }
      return;
    }
    if (res.status === 'joined') {
      siteToast('Клубқа қосылдың ✓');
      state.discover = null;
      state.mine = null;
      if (state.segment === 'find') {
        await loadDiscover();
      } else if (state.segment === 'mine') {
        await loadMine();
      }
    } else if (res.status === 'already_member') {
      siteToast('Сен бұл клубтың мүшесісің');
    }
  } catch (e) {
    console.warn('joinGroup failed', e);
    siteToast('Қосыла алмадық');
  }
}

// ── Leave ─────────────────────────────────────────────────────
async function leaveCurrentGroup() {
  if (!state.currentGroup) return;
  if (!confirm('Клубтан шынымен шығасың ба?')) return;
  const gid = state.currentGroup.group_id;
  try {
    const res = await api(`/api/groups/${gid}/leave`, { method: 'POST' });
    if (res.status === 'left') {
      siteToast('Клубтан шықтың');
      backToList();
      state.mine = null;
      state.discover = null;
    } else if (res.status === 'owner_cannot_leave') {
      alert(res.reason || 'Клуб құрушысы шыға алмайды');
    } else {
      siteToast('Жасалмады');
    }
  } catch (e) {
    console.warn('leave failed', e);
    siteToast('Шыға алмадық');
  }
}

// ── Kick member (owner) ───────────────────────────────────────
async function kickMember(telegramId) {
  if (!state.currentGroup) return;
  if (!confirm('Бұл мүшені шынымен шығарасың ба?')) return;
  const gid = state.currentGroup.group_id;
  try {
    const res = await api(`/api/groups/${gid}/kick`, {
      method: 'POST',
      body: JSON.stringify({ telegram_id: parseInt(telegramId, 10) }),
    });
    if (res.status === 'kicked') {
      siteToast('Мүше шығарылды');
      await loadMembers();
    } else {
      siteToast('Жасалмады');
    }
  } catch (e) {
    console.warn('kick failed', e);
    siteToast('Шығара алмадық');
  }
}

// ── Admin modal (owner: name/desc edit + invite) ──────────────
async function openAdminModal() {
  if (!state.groupDetail || !state.groupDetail.is_owner) return;
  const g = state.groupDetail;
  let invite = '';
  try {
    const r = await api(`/api/groups/${g.group_id}/invite`);
    // САЙТ сілтемесі басым: бұрын telegram_url берілетін де, шақырылған адам
    // ботқа түсетін. Енді сілтеме сайтта ашылып, бір басумен қосады.
    invite = r.site_url || r.telegram_url || '';
  } catch (_) {}
  removeAdminModal();
  const m = document.createElement('div');
  m.id = 'grAdminModal';
  m.className = 'gr-modal-bg';
  m.setAttribute('data-gr-action', 'admin-bg');
  m.innerHTML = `
    <div class="gr-modal">
      <button class="gr-modal-close" data-gr-action="admin-close">${SVG.close}</button>
      <div class="gr-modal-title">Клубты басқару</div>
      <label class="gr-field">
        <span>Клуб аты</span>
        <input class="gr-input" id="grAdminName" maxlength="150" value="${esc(g.name)}">
      </label>
      <label class="gr-field">
        <span>Сипаттама</span>
        <textarea class="gr-input gr-textarea" id="grAdminDesc" maxlength="1000">${esc(g.description || '')}</textarea>
      </label>
      <button class="gr-modal-btn" data-gr-action="admin-save">Сақтау</button>
      ${invite ? `
        <div class="gr-invite">
          <div class="gr-invite-label">Шақыру сілтемесі</div>
          <div class="gr-invite-url"><a href="${esc(invite)}" target="_blank">${esc(invite)}</a></div>
        </div>` : ''}

      <div style="border-top:1px solid color-mix(in srgb, var(--ink) 12%, transparent);margin:16px 0 12px;"></div>

      <div style="font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.6;margin-bottom:8px;">📅 Кездесу жариялау</div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
        <input class="gr-input" id="grMeetDate" type="date">
        <input class="gr-input" id="grMeetTime" type="time" value="16:00">
      </div>
      <input class="gr-input" id="grMeetTopic" maxlength="160" placeholder="Тақырыбы — мыс. «Қожаның балалық шағы»" style="margin-top:8px;">
      <input class="gr-input" id="grMeetPlace" maxlength="120" placeholder="Орны (немесе онлайн сілтеме)" style="margin-top:8px;">
      <textarea class="gr-input gr-textarea" id="grMeetQ" maxlength="1500" placeholder="Талқылау сұрақтары — әр жолға біреу" style="margin-top:8px;min-height:60px;"></textarea>
      <button class="gr-modal-btn" data-gr-action="meet-pub" style="margin-top:8px;">Кездесуді жариялау</button>

      <div style="font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.6;margin:16px 0 8px;">🗳 Дауыс ашу</div>
      <input class="gr-input" id="grVoteQ" maxlength="160" placeholder="Сұрақ — мыс. Қазанда не оқимыз?">
      <input class="gr-input" id="grVoteO1" maxlength="80" placeholder="1-нұсқа" style="margin-top:8px;">
      <input class="gr-input" id="grVoteO2" maxlength="80" placeholder="2-нұсқа" style="margin-top:8px;">
      <input class="gr-input" id="grVoteO3" maxlength="80" placeholder="3-нұсқа (міндетті емес)" style="margin-top:8px;">
      <button class="gr-modal-btn" data-gr-action="vote-open" style="margin-top:8px;">Дауысты ашу (7 күн)</button>

      <div style="font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.6;margin:16px 0 8px;">📣 Мүшелерге хабар</div>
      <textarea class="gr-input gr-textarea" id="grBcast" maxlength="120" placeholder="Push хабары — клубқа күніне 1 рет" style="min-height:48px;"></textarea>
      <button class="gr-modal-btn" data-gr-action="club-broadcast" style="margin-top:8px;">Жіберу</button>

      <div style="font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.6;margin:16px 0 8px;">💬 Клуб чаты</div>
      <input class="gr-input" id="grChatUrl" maxlength="200" placeholder="https://t.me/... немесе chat.whatsapp.com/...">
      <button class="gr-modal-btn" data-gr-action="chat-save" style="margin-top:8px;">Сілтемені сақтау</button>

      <div style="font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.6;margin:16px 0 8px;">🚪 Қабылдау режимі</div>
      <div class="gr-gd-tabs" id="grJoinMode" style="margin-top:0;">
        <button class="gr-gd-tab" data-gr-action="jmode" data-jm="open">Ашық</button>
        <button class="gr-gd-tab" data-gr-action="jmode" data-jm="request">Өтініммен</button>
        <button class="gr-gd-tab" data-gr-action="jmode" data-jm="invite">Тек шақырумен</button>
      </div>
      <div id="grReqBox" style="margin-top:10px;"></div>

      <div style="font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.6;margin:16px 0 8px;">🎖 Көмекші басшы</div>
      <div id="grRoleBox" style="font-size:12.5px;opacity:.7;">Мүшелер тізімінен таңдайсың →</div>
      <button class="gr-modal-btn" data-gr-action="role-pick" style="margin-top:8px;">Мүшелерден таңдау</button>

      <div style="font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;opacity:.6;margin:16px 0 8px;">🖼 Тарату материалдары</div>
      <button class="gr-modal-btn" data-gr-action="poster-week">Апта постерін жүктеу (PNG)</button>
      <button class="gr-modal-btn" data-gr-action="poster-qr" style="margin-top:8px;">QR постер (A4, басып шығару)</button>
    </div>
  `;
  document.body.appendChild(m);
  // Чат сілтемесін алдын ала толтыру (бар болса)
  const _cu = document.getElementById('grChatUrl');
  if (_cu && state.extras && state.extras.chat_url) _cu.value = state.extras.chat_url;
  // Қабылдау режимін белгілеу + өтінім кезегін жүктеу
  const mode = (state.extras && state.extras.join_mode) || 'open';
  document.querySelectorAll('#grJoinMode .gr-gd-tab').forEach((b) => {
    b.classList.toggle('active', b.dataset.jm === mode);
  });
  if (mode === 'request') loadJoinRequests();
  m.style.display = 'flex';
}

// ── Ф2+ (24.08): қабылдау режимі · өтінімдер · рөл · постерлер ──
async function setJoinMode(jm) {
  const gid = state.currentGroup && state.currentGroup.group_id;
  if (!gid) return;
  document.querySelectorAll('#grJoinMode .gr-gd-tab').forEach((b) => {
    b.classList.toggle('active', b.dataset.jm === jm);
  });
  try {
    await api(`/api/clubs/${gid}/settings`, { method: 'POST', body: JSON.stringify({
      chat_url: (document.getElementById('grChatUrl') || {}).value || '',
      join_mode: jm,
    }) });
    if (state.extras) state.extras.join_mode = jm;
    siteToast('Режим сақталды ✓');
    if (jm === 'request') loadJoinRequests();
    else { const b = document.getElementById('grReqBox'); if (b) b.innerHTML = ''; }
  } catch (_) { siteToast('Сақталмады'); }
}

async function loadJoinRequests() {
  const gid = state.currentGroup && state.currentGroup.group_id;
  const box = document.getElementById('grReqBox');
  if (!gid || !box) return;
  try {
    const r = await api(`/api/clubs/${gid}/requests`);
    const list = r.requests || [];
    box.innerHTML = list.length
      ? `<div style="font-size:12px;opacity:.7;margin-bottom:6px;">Кезекте ${list.length} өтінім</div>` +
        list.map((x) => `
        <div style="display:flex;align-items:center;gap:8px;padding:7px 0;border-top:.5px solid var(--gr-line);">
          <span style="flex:1;font-size:13px;">${esc(x.name)}</span>
          <button class="cx-rsvp on" data-gr-action="req-yes" data-tg="${x.telegram_id}">Қабылдау</button>
          <button class="cx-rsvp" data-gr-action="req-no" data-tg="${x.telegram_id}">×</button>
        </div>`).join('')
      : '<div style="font-size:12px;opacity:.6;">Өтінім жоқ.</div>';
  } catch (_) { box.innerHTML = ''; }
}

async function decideRequest(tg, accept) {
  const gid = state.currentGroup && state.currentGroup.group_id;
  if (!gid) return;
  try {
    await api(`/api/clubs/${gid}/requests/decide`, { method: 'POST',
      body: JSON.stringify({ telegram_id: parseInt(tg, 10), accept }) });
    loadJoinRequests();
  } catch (_) { siteToast('Жасалмады'); }
}

async function pickCoLeader() {
  const gid = state.currentGroup && state.currentGroup.group_id;
  if (!gid) return;
  try {
    const r = await api(`/api/groups/${gid}/members`);
    const list = (r.members || r.items || []).filter((m) => !m.is_me);
    if (!list.length) { siteToast('Мүше жоқ'); return; }
    const names = list.map((m, i) => `${i + 1}. ${fullName(m.first_name, m.last_name, false)}${m.role >= 1 ? ' ✓' : ''}`);
    const pick = prompt(`Көмекші басшы (нөмірін жаз, ✓ барын алу үшін де сол нөмір):\n\n${names.join('\n')}`);
    const idx = parseInt(pick, 10) - 1;
    if (!(idx >= 0 && idx < list.length)) return;
    const m = list[idx];
    const newRole = (m.role >= 1) ? 0 : 1;
    await api(`/api/clubs/${gid}/role`, { method: 'POST',
      body: JSON.stringify({ telegram_id: m.telegram_id, role: newRole }) });
    siteToast(newRole ? 'Көмекші басшы тағайындалды ✓' : 'Рөл алынды');
  } catch (_) { siteToast('Жасалмады'); }
}

// Апта постері — canvas-та салынады (сервер кітапханасыз), PNG болып жүктеледі.
async function makeWeekPoster() {
  const gid = state.currentGroup && state.currentGroup.group_id;
  if (!gid) return;
  let d;
  try { d = await api(`/api/clubs/${gid}/week-poster`); } catch (_) { siteToast('Дерек алынбады'); return; }
  const W = 1080, H = 1350;
  const c = document.createElement('canvas');
  c.width = W; c.height = H;
  const x = c.getContext('2d');
  // Фон — түнгі кітап дүкені
  x.fillStyle = '#14100C'; x.fillRect(0, 0, W, H);
  const g = x.createRadialGradient(W / 2, 120, 40, W / 2, 120, 700);
  g.addColorStop(0, 'rgba(232,179,86,.30)'); g.addColorStop(1, 'rgba(232,179,86,0)');
  x.fillStyle = g; x.fillRect(0, 0, W, 800);
  x.textAlign = 'center';
  x.fillStyle = '#D8A94E'; x.font = '600 30px "IBM Plex Mono", monospace';
  x.fillText(`PARAQTA · ${d.week}-АПТА`, W / 2, 130);
  x.fillStyle = '#F0E8DA'; x.font = '700 72px Georgia, "PT Serif", serif';
  const nm = (d.club || '').length > 20 ? d.club.slice(0, 19) + '…' : d.club;
  x.fillText(nm, W / 2, 250);
  // Апта саны
  x.fillStyle = '#E8B356'; x.font = '700 160px Georgia, serif';
  x.fillText(String(d.total), W / 2, 470);
  x.fillStyle = '#C9BCA6'; x.font = '400 34px "PT Sans", sans-serif';
  x.fillText('бет · осы аптада бірге оқыдық', W / 2, 525);
  // Топ-3
  const medals = ['🥇', '🥈', '🥉'];
  (d.top || []).forEach((t, i) => {
    const y = 680 + i * 110;
    x.fillStyle = 'rgba(255,255,255,.05)';
    x.fillRect(140, y - 55, W - 280, 88);
    x.textAlign = 'left';
    x.font = '400 44px "PT Sans", sans-serif'; x.fillStyle = '#F0E8DA';
    x.fillText(`${medals[i]} ${t.name}`, 185, y);
    x.textAlign = 'right';
    x.fillStyle = '#D8A94E'; x.font = '600 44px "IBM Plex Mono", monospace';
    x.fillText(`${t.pages} бет`, W - 185, y);
    x.textAlign = 'center';
  });
  if (d.rank) {
    x.fillStyle = '#D8A94E'; x.font = '400 36px "PT Sans", sans-serif';
    x.fillText(`🏆 ПАРАҚТА лигасында ${d.rank}-орын`, W / 2, 1120);
  }
  x.fillStyle = '#96897A'; x.font = '400 28px "IBM Plex Mono", monospace';
  x.fillText('paraqta.kz', W / 2, 1265);
  c.toBlob(async (blob) => {
    const file = new File([blob], `${d.club}-${d.week}-apta.png`, { type: 'image/png' });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try { await navigator.share({ files: [file], title: d.club }); return; } catch (_) {}
    }
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = file.name;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    siteToast('Постер жүктелді ✓');
  }, 'image/png');
}

function removeAdminModal() {
  const m = document.getElementById('grAdminModal');
  if (m) m.remove();
}

async function saveAdminChanges() {
  const m = document.getElementById('grAdminModal');
  if (!m || !state.groupDetail) return;
  const nameInput = m.querySelector('#grAdminName');
  const descInput = m.querySelector('#grAdminDesc');
  const name = (nameInput.value || '').trim();
  const desc = (descInput.value || '').trim();
  if (!name) { siteToast('Клуб аты бос'); return; }
  try {
    const res = await api(`/api/groups/${state.groupDetail.group_id}/update`, {
      method: 'POST',
      body: JSON.stringify({ name, description: desc }),
    });
    if (res.ok) {
      siteToast('Сақталды ✓');
      state.groupDetail.name = name;
      state.groupDetail.description = desc;
      removeAdminModal();
      renderGroupShell(state.currentGroup.group_id);
    } else {
      siteToast('Сақталмады');
    }
  } catch (e) {
    console.warn('admin save failed', e);
    siteToast('Сақталмады');
  }
}

// ── Nav ───────────────────────────────────────────────────────
function backToList() {
  state.currentGroup = null;
  renderListScreen();
}

function setSegment(seg) {
  if (state.segment === seg) return;
  state.segment = seg;
  state.searchResults = null;
  renderListScreen();
}

function setGroupTab(tab) {
  state.groupTab = tab;
  // Tab active class жаңарту (renderGroupBody тек body жаңартады)
  const r = rootEl();
  if (r) {
    r.querySelectorAll('.gr-gd-tab').forEach((el) => {
      el.classList.toggle('active', el.dataset.gtab === tab);
    });
  }
  renderGroupBody();
  if (tab === 'rank' && !state.ranking) loadRanking();
  if (tab === 'mem' && !state.members) loadMembers();
}

function setMetric(metric) {
  if (state.metric === metric) return;
  state.metric = metric;
  state.ranking = null;
  renderGroupBody();
  loadRanking();
}

function setPeriod(period) {
  if (state.period === period) return;
  state.period = period;
  state.ranking = null;
  renderGroupBody();
  loadRanking();
}

// ── Group create modal (Premium-only) ─────────────────────────
function openCreateModal() {
  removeCreateModal();
  const m = document.createElement('div');
  m.id = 'grCreateModal';
  m.className = 'gr-modal-bg';
  m.setAttribute('data-gr-action', 'create-bg');
  m.innerHTML = `
    <div class="gr-modal">
      <button class="gr-modal-close" data-gr-action="create-close">${SVG.close}</button>
      <div class="gr-modal-title">Жаңа клуб ашу</div>
      <label class="gr-field">
        <span>Клуб аты</span>
        <input class="gr-input" id="grCreateName" maxlength="150" placeholder="Мысалы: Кітап сүйер">
      </label>
      <label class="gr-field">
        <span>Сипаттама (опционал)</span>
        <textarea class="gr-input gr-textarea" id="grCreateDesc" maxlength="1000"
          placeholder="Клуб мақсаты, қандай кітаптар оқимыз..."></textarea>
      </label>
      <div class="gr-field">
        <span>Көріну түрі</span>
        <div style="display:flex;gap:8px;margin-top:6px;">
          <button type="button" id="grVisPublic" style="flex:1;padding:11px 8px;border-radius:12px;cursor:pointer;border:1px solid var(--ac);background:color-mix(in srgb,var(--ac) 8%,transparent);font-family:Onest,sans-serif;text-align:center;">
            <div style="font-size:14px;">🌐 Ашық</div>
            <div style="font-size:10px;opacity:.6;margin-top:2px;">табудан көрінеді</div>
          </button>
          <button type="button" id="grVisPrivate" style="flex:1;padding:11px 8px;border-radius:12px;cursor:pointer;border:1px solid color-mix(in srgb,var(--ink) 12%,transparent);background:transparent;font-family:Onest,sans-serif;text-align:center;">
            <div style="font-size:14px;">🔒 Жабық</div>
            <div style="font-size:10px;opacity:.6;margin-top:2px;">тек сілтемемен</div>
          </button>
        </div>
      </div>
      <button class="gr-modal-btn" data-gr-action="create-submit">Клубты ашу</button>
    </div>
  `;
  document.body.appendChild(m);
  m.style.display = 'flex';
  // Visibility toggle (ашық әдепкі)
  const pub = m.querySelector('#grVisPublic');
  const prv = m.querySelector('#grVisPrivate');
  const setVis = (isPub) => {
    m.dataset.visPublic = isPub ? '1' : '0';
    pub.style.borderColor = isPub ? 'var(--ac)' : 'color-mix(in srgb,var(--ink) 12%,transparent)';
    pub.style.background = isPub ? 'color-mix(in srgb,var(--ac) 8%,transparent)' : 'transparent';
    prv.style.borderColor = !isPub ? 'var(--ac)' : 'color-mix(in srgb,var(--ink) 12%,transparent)';
    prv.style.background = !isPub ? 'color-mix(in srgb,var(--ac) 8%,transparent)' : 'transparent';
  };
  m.dataset.visPublic = '1';
  if (pub) pub.addEventListener('click', () => setVis(true));
  if (prv) prv.addEventListener('click', () => setVis(false));
  setTimeout(() => {
    const inp = m.querySelector('#grCreateName');
    if (inp) inp.focus();
  }, 50);
}

function removeCreateModal() {
  const m = document.getElementById('grCreateModal');
  if (m) m.remove();
}

async function submitCreateGroup() {
  const m = document.getElementById('grCreateModal');
  if (!m) return;
  const name = (m.querySelector('#grCreateName').value || '').trim();
  const desc = (m.querySelector('#grCreateDesc').value || '').trim();
  const isPublic = m.dataset.visPublic !== '0';  // әдепкі — ашық
  if (!name || name.length < 2) { siteToast('Клуб аты тым қысқа'); return; }
  const btn = m.querySelector('.gr-modal-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Құрылуда…'; }
  try {
    const res = await api('/api/groups/create', {
      method: 'POST',
      body: JSON.stringify({ name, description: desc, is_public: isPublic }),
    });
    if (res.status === 'premium_required') {
      removeCreateModal();
      try {
        const mod = await import('../premium-lock/modal.js');
        mod.showPremiumLockModal('group-join');
      } catch (_) { siteToast('PARAQTA-ның Жан досы болыңыз'); }
      return;
    }
    if (res.ok && res.status === 'created') {
      siteToast('Клуб құрылды ✓');
      removeCreateModal();
      state.mine = null;
      await loadMine();
      // Жаңа топты ашу
      if (res.group_id) openGroup(res.group_id);
    } else {
      siteToast('Құру сәтсіз');
    }
  } catch (e) {
    console.warn('create group failed', e);
    siteToast('Желі қатесі');
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = 'Клубты ашу'; }
  }
}

async function showCreateLocked() {
  try {
    const mod = await import('../premium-lock/modal.js');
    mod.showPremiumLockModal('group-join');
  } catch (_) {
    siteToast('Клуб ашу — Жан дос мүмкіндігі');
  }
}

// ── Global event delegation ───────────────────────────────────
function bindEvents() {
  const r = rootEl();
  if (!r) return;
  if (r._grBound) return;
  r._grBound = true;
  r.addEventListener('click', (e) => {
    const tgt = e.target.closest('[data-gr-action]');
    if (!tgt || !r.contains(tgt)) return;
    const action = tgt.dataset.grAction;
    e.preventDefault();
    e.stopPropagation();
    switch (action) {
      case 'seg':
        setSegment(tgt.dataset.seg);
        break;
      case 'open-group': {
        const gid = parseInt(tgt.dataset.gid, 10);
        if (gid) openGroup(gid);
        break;
      }
      case 'join': {
        const gid = parseInt(tgt.dataset.gid, 10);
        if (gid) joinGroup(gid);
        break;
      }
      case 'liga-full':
        renderLigaScreen();
        break;
      case 'liga-reyting':
        // Жинақы карточка → Рейтингтің «Клубтар» қойындысы (IA көшуі 01.09)
        window._pendingLeadersEntity = 'clubs';
        show('leaders');
        break;
      case 'liga-rules':
        showLigaRules();
        break;
      case 'liga-share': {
        const nm = tgt.dataset.nm || '';
        const ym = tgt.dataset.ym || '';
        const txt = `🏆 ${_ymKk(ym)} лига чемпионы — ${nm}! PARAQTA клубтар лигасы: paraqta.kz`;
        if (navigator.share) { navigator.share({ text: txt }).catch(() => {}); }
        else { navigator.clipboard?.writeText(txt); siteToast('Мәтін көшірілді — чатқа тастай сал'); }
        break;
      }
      case 'invite-friend':
        import('../../utils/invite.js').then((m) => m.shareInvite({ from: 'birge-event' })).catch(() => {});
        break;
      case 'back-to-list':
        backToList();
        break;
      case 'exit':
        show('oqu');
        break;
      case 'retry':
        loadCurrentSegment();
        break;
      case 'gtab':
        setGroupTab(tgt.dataset.gtab);
        break;
      case 'metric':
        setMetric(tgt.dataset.metric);
        break;
      case 'period':
        setPeriod(tgt.dataset.period);
        break;
      case 'rsvp':
        doRsvp();
        break;
      case 'chat-gate':
        openProfileGate(tgt.dataset.url || '');
        break;
      case 'vote-cast':
        doVoteCast(parseInt(tgt.dataset.idx, 10));
        break;
      case 'meet-pub':
        doMeetPub();
        break;
      case 'vote-open':
        doVoteOpen();
        break;
      case 'club-broadcast':
        doBroadcast();
        break;
      case 'chat-save':
        doChatSave();
        break;
      case 'jmode':
        setJoinMode(tgt.dataset.jm);
        break;
      case 'req-yes':
        decideRequest(tgt.dataset.tg, true);
        break;
      case 'req-no':
        decideRequest(tgt.dataset.tg, false);
        break;
      case 'role-pick':
        pickCoLeader();
        break;
      case 'poster-week':
        makeWeekPoster();
        break;
      case 'poster-qr':
        if (state.currentGroup) {
          window.open(`/club/${state.currentGroup.group_id}/qr`, '_blank', 'noopener');
        }
        break;
      case 'open-create':
        openCreateModal();
        break;
      case 'create-locked':
        showCreateLocked();
        break;
      case 'leave':
        leaveCurrentGroup();
        break;
      case 'kick': {
        const tid = tgt.dataset.tid;
        if (tid) kickMember(tid);
        break;
      }
      case 'open-admin':
        openAdminModal();
        break;
      case 'post-submit':
        submitPost();
        break;
      case 'reply-submit':
        submitReply(tgt.dataset.pid);
        break;
      case 'post-delete':
        deletePost(tgt.dataset.pid);
        break;
    }
  });
  r.addEventListener('input', (e) => {
    if (e.target && e.target.id === 'grSearchInput') {
      onSearchInput(e.target.value);
    }
  });
  if (!document.body._grAdminBound) {
    document.body._grAdminBound = true;
    document.body.addEventListener('click', (e) => {
      const t = e.target.closest('[data-gr-action]');
      if (!t) return;
      const a = t.dataset.grAction;
      if (a === 'liga-sheet-close') { removeLigaSheet(); }
      else if (a === 'liga-sheet-bg' && e.target.id === 'grLigaSheet') { removeLigaSheet(); }
      else if (a === 'admin-close') { removeAdminModal(); }
      else if (a === 'admin-bg' && e.target.id === 'grAdminModal') { removeAdminModal(); }
      else if (a === 'admin-save') { saveAdminChanges(); }
      else if (a === 'create-close') { removeCreateModal(); }
      else if (a === 'create-bg' && e.target.id === 'grCreateModal') { removeCreateModal(); }
      else if (a === 'create-submit') { submitCreateGroup(); }
      // 24.08: басшы құралдары модаль ІШІНДЕ — модаль document.body-ге
      // қосылатындықтан түбір тыңдаушысына жетпейді, сондықтан осында.
      else if (a === 'meet-pub') { doMeetPub(); }
      else if (a === 'vote-open') { doVoteOpen(); }
      else if (a === 'club-broadcast') { doBroadcast(); }
      else if (a === 'chat-save') { doChatSave(); }
      else if (a === 'jmode') { setJoinMode(t.dataset.jm); }
      else if (a === 'req-yes') { decideRequest(t.dataset.tg, true); }
      else if (a === 'req-no') { decideRequest(t.dataset.tg, false); }
      else if (a === 'role-pick') { pickCoLeader(); }
      else if (a === 'poster-week') { makeWeekPoster(); }
      else if (a === 'poster-qr') {
        if (state.currentGroup) {
          window.open(`/club/${state.currentGroup.group_id}/qr`, '_blank', 'noopener');
        }
      }
    });
  }
}

// ── Public entry ──────────────────────────────────────────────
export async function loadGroups() {
  const r = rootEl();
  if (!r) return;
  bindEvents();
  // v3: бетке әр кірген сайын лига/карточка кэші жаңарады (сервер кэші өз алдына).
  _ligaPromise = null;
  _myCardPromise = null;
  // Stage 7.4: window._pendingGroupOpen (today-v2 group card click)
  const pending = window._pendingGroupOpen;
  if (pending) {
    window._pendingGroupOpen = null;
    openGroup(pending);
    return;
  }
  // 24.08: ашық клуб бетінен (/club/{id} → /?join_club={id}) келген шақыру.
  // Логин болмаса 401 түседі — кодты сақтап қоямыз, келесі ашқанда қосылады.
  // Шақыру КОДЫМЕН қосылу (/?join=КОД) — жабық клубқа да өткізеді, себебі
  // кодты білу шақырылған деген сөз. Telegram керек емес.
  const pc = localStorage.getItem('pq_join_code');
  if (pc) {
    // ❗api() қатені жұтып `{}` қайтарады, ал бізге СТАТУС керек: 401 болса
    // код сақталып қалуы тиіс (логиннен кейін қайталанады), 404 болса
    // өшірілуі тиіс (әйтпесе әр кіргенде қайта-қайта әрекеттенеді).
    try {
      const r = await fetch('/api/groups/join-by-code', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: pc }),
      });
      if (r.ok) {
        const res = await r.json();
        if (res && res.gid) {
          localStorage.removeItem('pq_join_code');
          siteToast(res.status === 'joined'
            ? `«${res.name}» клубына қосылдың ✓` : 'Сен бұл клубтың мүшесісің');
          openGroup(res.gid);
          return;
        }
      } else if (r.status === 404 || r.status === 400) {
        localStorage.removeItem('pq_join_code');
        siteToast('Шақыру ескірген немесе қате');
      }
      // 401 — логинсіз: кодты ҚАЛДЫРАМЫЗ, кіргеннен кейін өзі қосылады.
    } catch (_) { /* желі — келесі жолы қайталанады */ }
  }

  const pj = localStorage.getItem('pq_join_club');
  if (pj) {
    try {
      const res = await api(`/api/groups/${encodeURIComponent(pj)}/join`, { method: 'POST' });
      if (res && (res.status === 'joined' || res.status === 'already_member')) {
        localStorage.removeItem('pq_join_club');
        siteToast(res.status === 'joined' ? 'Клубқа қосылдың ✓' : 'Сен бұл клубтың мүшесісің');
        openGroup(parseInt(pj, 10));
        return;
      }
    } catch (_) { /* логинсіз — кейін қайталанады */ }
  }
  renderListScreen();
}
